<template>
  <div>
    <el-backtop style="right: 10px;width:30px;height:30px"><img src="@/assets/up.png" style="width: 40px;height: 40px;">
    </el-backtop>
    <el-row>
      <el-col :span="5">
        <el-breadcrumb class="navcss" separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ name: 'idclist' }">IDC列表</el-breadcrumb-item>
          <el-breadcrumb-item>Group信息管理</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
      <el-col :span="19" style="margin-top: -8px;">
        <el-button size="small" type="primary" @click="globalTatic"
                   v-if="btnInList('idc_groupInfo','idc_setGlobalStrategy')">设置全局路由策略
        </el-button>
        <el-button size="small" type="primary" @click="globalVerifyClick()"
                   v-if="btnInList('idc_groupInfo','idc_group_verify')">全局校验
        </el-button>

        <!--        <el-radio-group v-model="isDelete" @change="deleteChange" style="float: right;margin-left: 20px">-->
        <!--          <el-radio-button label="全部"></el-radio-button>-->
        <!--          <el-radio-button label="正常"></el-radio-button>-->
        <!--        </el-radio-group>-->
        <el-switch
          v-model="isDelete" @change="deleteChange" style="float: right;margin-left: 20px;margin-top: 10px"
          active-color="#13ce66"
          inactive-color="rgb(64,158,255)"
          active-text="全部"
          inactive-text="正常">
        </el-switch>
        <el-input v-model="search" placeholder="搜索" @change="searchData" style="width: 300px;float:right;">
          <el-button slot="append" icon="el-icon-search" @click="searchData"></el-button>
        </el-input>


        <!--        <a href="javaScript:;" @click="filterData"><img src="@/assets/filter.svg"-->
        <!--                                                        style="width: 30px;height: 30px;right: 10px;position:fixed;z-index: 1000"></a>-->
      </el-col>
    </el-row>
    <el-table :data="groupData" style="width: 100%; margin-top: 20px" :row-class-name="status_change">
      <!--        <el-table-column type="index" width="50"></el-table-column>-->
      <el-table-column align="center" prop="projectName" label="项目"></el-table-column>
      <el-table-column align="center" prop="appkey" label="appkey"></el-table-column>
      <el-table-column align="center" prop="groupname" label="groupname"></el-table-column>
      <el-table-column align="center" prop="groupAlias" label="groupAlias"></el-table-column>
      <el-table-column align="center" label="路由策略" width="120">
        <template v-slot="{row}">
          <div v-if="row.strategyDesc">聚合:{{ row.strategyDesc }}</div>
          <div v-else>
            <div>聚合:未设置</div>
          </div>
          <div v-if="row.strategyDescMeeting">会议:{{ row.strategyDescMeeting }}</div>
          <div v-else>
            <div>会议:未设置</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="roam" label="是否漫游">
        <template slot-scope="scope">
          <div v-if="scope.row.roam == 1">聚合:漫游</div>
          <div v-else-if="scope.row.roam == 2">聚合:不漫游</div>
          <div v-else>聚合:未设置</div>
          <div v-if="scope.row.roamMeeting == 1">会议:漫游</div>
          <div v-else-if="scope.row.roamMeeting == 2">会议:不漫游</div>
          <div v-else>会议:未设置</div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="deleteFlag" label="状态">
        <template slot-scope="scope">
          <div v-if="scope.row.deleteFlag == 1">正常</div>
          <div v-else>
            <el-tag type="danger">已删除</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="createTime" label="创建时间"></el-table-column>
      <el-table-column align="center" label="操作" width="400">
        <template v-slot="{row}">
          <el-button :disabled="row.deleteFlag == 0 || !row.strategyDesc || !row.strategyDescMeeting" size="mini"
                     type="primary" @click="select(row)"
                     v-if="btnInList('idc_groupInfo','idc_groupInfo_bind')">绑定网元
          </el-button>
          <el-button :disabled="row.deleteFlag == 0" size="mini" type="primary" @click="tactic(row)"
                     v-if="btnInList('idc_groupInfo','idc_groupInfo_setStrategy')">设置路由策略
          </el-button>
          <el-button :disabled="row.deleteFlag == 0" size="mini" type="primary" @click="viewNE(row)"
                     v-if="btnInList('idc_groupInfo','idc_groupInfo_showNet')">显示绑定网元
          </el-button>
          <el-button  size="mini" type="primary" @click="globalVerifyClick(row)"
                     v-if="btnInList('idc_groupInfo','idc_group_verify')">校验
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--设置路由策略-->
    <el-dialog
      :title="'设置路由策略'"
      :visible.sync="route"
      width="35%">
      <el-tabs v-model="routeActiveName" @tab-click="routeHandleClick">
        <el-tab-pane label="聚合" name="1">
          <el-form :model="juheform">
            <el-form-item label="路由策略： ">
              <el-radio-group v-model="juheform.strategyType">
                <el-radio v-for="item in routestrategyArray" :label="item.strategyType">{{ item.strategyDesc }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="是否漫游： ">
              <el-radio-group v-model="juheform.roamRadio">
                <el-radio :label=0>不设置</el-radio>
                <el-radio :label=1>漫游</el-radio>
                <el-radio :label=2>不漫游</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="会议" name="2">
          <el-form :model="huiyiform">
            <el-form-item label="路由策略： ">
              <el-radio-group v-model="huiyiform.strategyType">
                <el-radio v-for="item in routestrategyArray" :label="item.strategyType">{{ item.strategyDesc }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="是否漫游： ">
              <el-radio-group v-model="huiyiform.roamRadio">
                <el-radio :label=0>不设置</el-radio>
                <el-radio :label=1>漫游</el-radio>
                <el-radio :label=2>不漫游</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
      <el-row style="text-align: center; margin-top: 20px">
        <el-button type="primary" @click="saveRouteClick()">提 交</el-button>
        <el-button @click="resetForm()">关 闭</el-button>
      </el-row>
    </el-dialog>
    <el-pagination
      class="fy"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10,20,30,40]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalElement"
    ></el-pagination>
    <SelectNet-element v-if="selectnet" :selectnet="selectnet" :groupObject="groupObject"
                       @editCallback="editCallback"/>
    <BindNet-element v-if="bindNEVisible" :bindNEVisible="bindNEVisible" :groupObject="groupObject"
                     @editCallback="editCallback"/>

    <!--      设置全局路由策略-->
    <el-dialog
      :title="'设置全局路由策略'"
      :visible.sync="globaltatic"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="30%">
      <el-tabs v-model="hasPrivateNode" @tab-click="routeChange">
        <el-tab-pane label="无资源" name="false">
          <el-form :model="defaultform">
            <el-form-item label="路由策略： ">
              <el-radio-group v-model="defaultform.strategyType">
                <el-radio v-for="item in routestrategyArray" :label="item.strategyType">{{ item.strategyDesc }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="是否漫游： ">
              <el-radio-group v-model="defaultform.roam">
                <el-radio :label=0>不设置</el-radio>
                <el-radio :label=1>漫游</el-radio>
                <el-radio :label=2>不漫游</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="有资源 无路由及漫游策略" name="true">
          <el-form :model="hasSourceform">
            <el-form-item label="路由策略： ">
              <el-radio-group v-model="hasSourceform.strategyType">
                <el-radio v-for="item in routestrategyArray" :label="item.strategyType">{{ item.strategyDesc }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="是否漫游： ">
              <el-radio-group v-model="hasSourceform.roam">
                <el-radio :label=0>不设置</el-radio>
                <el-radio :label=1>漫游</el-radio>
                <el-radio :label=2>不漫游</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
      <el-row style="text-align: center; margin-top: 20px">
        <el-button type="primary" @click="saveWhole()">提 交</el-button>
        <el-button @click="globaltatic=false">关 闭</el-button>
      </el-row>
    </el-dialog>

    <!--      全局校验-->
    <el-dialog
      :visible.sync="verifyVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="600px" @close="close">
      <template #title>
        <div class="check-wrapper">
          <span style="font-size: 20px;margin-right:5px;color: #2b2b2b">校验</span>
          <div class="loader" v-if="isLoading"></div>
          <img src="@/assets/complete.png" v-else
               style="width:23px;height:23px;">
        </div>
      </template>
      <el-tree :data="treeData" :props="defaultProps"
               :default-expand-all="true">
        <template #default="{ node, data }">
          <span v-if="node.level == 3">
            <div style="display: inline-block;width: 100px;">实例ID: {{ data.label }}</div>
            <div style="margin-left: 20px;display: inline-block;width: 100px;">nodeId: {{ data.nodeId }}</div>
            <el-tooltip placement="top-start">
              <div slot="content"><span v-html="data.desc"></span></div>
              <div v-html="data.desc" style="margin-left: 20px;display: inline-block;max-width: 300px;"></div>
            </el-tooltip>
          </span>
          <span v-else>{{ data.label }}</span>
        </template>
      </el-tree>
      <!--      <el-row style="text-align: center; margin-top: 20px">-->
      <!--        &lt;!&ndash;        <el-button type="primary" @click="saveWhole()">提 交</el-button>&ndash;&gt;-->
      <!--        <el-button @click="verifyVisible=false">关 闭</el-button>-->
      <!--      </el-row>-->
    </el-dialog>
  </div>
</template>

<script>
import SelectNetElement from './SelectNetElement.vue'
import BindNetElement from './BindNetElement.vue'
import {mapMutations, mapState} from "vuex";

export default {
  name: "GroupInfo",
  components: {SelectNetElement, BindNetElement},
  data() {
    return {
      isStreamActive:false,
      reader: null,
      isLoading: false,
      treeData: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      groupObject: null,
      verifyVisible: false,
      globaltatic: false,
      hasPrivateNode: "false",
      selectnet: false,
      route: false,
      bindNEVisible: false,
      currentPage: 1,
      pageSize: 10,
      totalElement: 0,
      condition: "",
      search: "",
      routeActiveName: "1",
      privateTableData: [],
      pubTableData: [],
      contentMultipleSelection: [], // 添加内容时已选中的内容
      groupData: [],
      selectItem: null,
      strategyDesc: [],
      routestrategyArray: [],
      defaultRoutestrategy: [],
      selectRow: {},
      isDelete: "",
      isFilter: false,
      deleteFlag: 1,
      juheform: {
        strategyType: 1,
        roamRadio: 1,
      },
      huiyiform: {
        strategyType: 1,
        roamRadio: 1,
      },
      defaultform: {
        strategyType: 1,
        roam: 0,
      },
      hasSourceform: {
        strategyType: 1,
        roam: 0,
      }
    }
  },
  watch: {
    treeData: {
      handler(newValue) {
        if (newValue && newValue.length > 0) {
          this.$nextTick(() => {
            const dialogBody = this.$el.querySelector('.el-dialog__body');
            if (dialogBody) {
              const threshold = 100;
              const isNearBottom = dialogBody.scrollHeight - dialogBody.scrollTop - dialogBody.clientHeight <= threshold;

              if (this.isAtBottom || isNearBottom) {
                dialogBody.scrollTop = dialogBody.scrollHeight;
              }
            }
          });
        }
      },
      deep: true
    }
  },
  beforeDestroy() {
    this.stopStream()
  },
  methods: {
    ...mapMutations(['getListOperations']),
    deleteChange(e) {
      this.currentPage = 1;
      if (e) {
        this.isFilter = false;
        // this.deleteFlag = 0;
        this.initGroupList();
      } else {
        this.isFilter = true;
        this.deleteFlag = 1;
        this.initGroupList();
      }
    },
    open() {
      this.$confirm('当前数据未保存，是否保存?', '提示', {
        confirmButtonText: '保存',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.saveWhole()
      }).catch(() => {
        this.getDefaultRoutestrategy();
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    saveConfirm(strategyType, roamRadio, type) {
      this.$confirm('当前数据未保存，是否保存?', '提示', {
        confirmButtonText: '保存',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.saveRoute(strategyType, roamRadio, type)
      }).catch(() => {
        this.huiyiform.strategyType = this.selectItem.strategyTypeMeeting;
        this.huiyiform.roamRadio = this.selectItem.roamMeeting;
        this.juheform.strategyType = this.selectItem.strategyType;
        this.juheform.roamRadio = this.selectItem.roam;
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    routeChange(tab) {
      let _this = this;
      if (tab.name == "false") {
        _this.defaultRoutestrategy.forEach(e => {
          if (e.hasPrivateNode) {
            if (e.strategyType == _this.hasSourceform.strategyType && e.roam == _this.hasSourceform.roam) {

            } else {
              _this.open();
            }
          }
        })
      } else {
        _this.defaultRoutestrategy.forEach(e => {
          if (!e.hasPrivateNode) {
            if (e.strategyType == _this.defaultform.strategyType && e.roam == _this.defaultform.roam) {

            } else {
              _this.open();
            }
          }
        })
      }
    },
    getDefaultRoutestrategy() {
      let _this = this;
      this.defaultRoutestrategy = [];
      //this.hasSourceform = [];
      this.$axios.get(this.baseUrl3 + 'management3/source/getDefaultRoutestrategy')
        .then(({data: {code, data, msg}}) => {
          if (code == 20000) {
            this.defaultRoutestrategy = data.defaultRouteStrategy
            if (_this.defaultRoutestrategy && _this.defaultRoutestrategy.length > 0) {
              _this.defaultRoutestrategy.forEach(e => {
                if (!e.hasPrivateNode) {
                  this.defaultform.strategyType = e.strategyType;
                  this.defaultform.roam = e.roam;
                } else {
                  this.hasSourceform.strategyType = e.strategyType;
                  this.hasSourceform.roam = e.roam;
                }
              })
            }
          } else {
            this.$message.error('操作失败,' + msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    saveWhole() {
      let _this = this;
      let paraArray = [];
      let obj = {
        hasPrivateNode: false,
        strategyType: this.defaultform.strategyType,
        roam: this.defaultform.roam
      }
      paraArray.push(obj);

      let hasSourceObj = {
        hasPrivateNode: true,
        strategyType: this.hasSourceform.strategyType,
        roam: this.hasSourceform.roam
      }
      paraArray.push(hasSourceObj);

      let data = {
        defaultRouteStrategy: paraArray
      }
      this.defaultRoutestrategy = [];
      this.$axios.post(this.baseUrl3 + 'management3/source/updateDefaultRoutestrategy', data)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            _this.$message({showClose: true, message: "设置成功", type: 'success'})
            this.defaultRoutestrategy = paraArray;
            // _this.globaltatic = false;
          } else {
            _this.$message({showClose: true, message: msg, type: 'error'})
            console.log(msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 模拟流数据处理函数
    processData(data) {
      const uuid = data.uuid;
      let uuidNode = {};

      // 如果 uuid 不存在，创建一个新节点
      if (this.treeData.length == 0 || uuid != this.treeData[this.treeData.length - 1].uuid) {
        uuidNode = {
          uuid: data.uuid,
          label: data.groupAlias,  // 第一级显示 groupAlias
          children: []  // 第二级开始放置子节点
        };
        this.treeData.push(uuidNode);  // 添加到树数据中
      } else {
        uuidNode = this.treeData[this.treeData.length - 1]
      }


      if (data.moduleType == "") {
        return
      }

      let moduleNode = {}

      // 判断是否为新的 moduleType，如果存在，放到第二级
      if (uuidNode.children.length == 0 || data.moduleType != uuidNode.children[uuidNode.children.length - 1].label) {
        moduleNode = {
          label: data.moduleType,
          children: []  // 继续往下放置子节点
        }
        uuidNode.children.push(moduleNode)
      } else {
        moduleNode = uuidNode.children[uuidNode.children.length - 1]
      }
      let instanceNode = {}
      if (moduleNode.children.length == 0 || data.instanceId != moduleNode.children[moduleNode.children.length - 1].label) {
        instanceNode = {
          label: data.instanceId,
          nodeId: data.nodeId,
          desc: data.desc
        }
        moduleNode.children.push(instanceNode)
      } else {
        moduleNode.children[moduleNode.children.length - 1].desc = data.desc;
      }
    },
    globalVerifyClick(row) {
      this.treeData = [];
      this.verifyVisible = true;
      this.isLoading = true;
      this.globalVerify(row);
      this.$nextTick(() => {
        const dialogBody = this.$el.querySelector('.el-dialog__body');
        dialogBody.addEventListener('scroll', this.handleScroll);
      })
    },
    handleScroll(event) {
      const dialogBody = event.target;
      const threshold = 100;
      this.isAtBottom = dialogBody.scrollHeight - dialogBody.scrollTop - dialogBody.clientHeight <= threshold;
    },
    close(){
      this.verifyVisible=false;
      this.stopStream();
    },
    // 全局校验
    globalVerify(row) {
      let that = this;
      that.isStreamActive=true;
      let arr=[]
      if (row){
        arr.push(row.groupuuid)
      }
      fetch(that.baseUrl3 + "instance/check/paas/group", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          "Connection": "keep-alive",
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify(arr),
      })
        .then(response => {
          if (!response.ok) {
            throw new Error('网络错误，状态码: ' + response.status);
          }
          that.reader = response.body.getReader(); // 获取流式读取器
          return that.reader
        })
        .then(async reader => {
          const decoder = new TextDecoder(); // 用于解码二进制数据
          let buffer = "";
          const stream = new ReadableStream({
            start(controller) {
              function read() {
                if (!that.isStreamActive) {
                  reader.cancel(); // 如果流被主动停止，则取消流
                  console.log("流已被停止");
                  controller.close();
                  return;
                }
                reader.read().then(({done, value}) => {
                  if (done) {
                    that.isLoading = false;
                    console.log("数据读取完毕");
                    controller.close();
                    return;
                  }
                  buffer += decoder.decode(value, {stream: true});
                  // 解析流数据（按行拆分）
                  const lines = buffer.split("\n");
                  buffer = lines.pop(); // 最后一行可能是不完整的，保留到下次解析

                  for (let line of lines) {
                    line = line.trim();
                    if (!line) continue; // 跳过空行
                    try {
                      if (line.startsWith("data: ")) {
                        line = line.substring(6).trim();
                      }
                      const jsonData = JSON.parse(line);
                      // 这里可以处理接收到的数据
                      if (jsonData.code == 20000) {
                        if (jsonData.data) {
                          if (jsonData.data.uuid) {
                            that.processData(jsonData.data);
                          }

                        } else {

                        }

                      } else {

                      }
                    } catch (err) {
                      console.warn("JSON 解析失败，跳过此行:", line, err);
                    }
                  }

                  read();
                }).catch(error => {
                  console.error("读取流数据失败:", error);
                });
              }

              read();
            }
          });

          return new Response(stream);
        })
        .catch(error => {
          console.error('请求失败:', error);
        });
    },
    // 断开流
    stopStream() {
      this.isStreamActive = false; // 停止流
      if (this.reader) {
        this.reader.cancel(); // 主动断开流
        console.log("流已停止");
      }
    },
    globalTatic() {
      this.hasPrivateNode = "false";
      this.globaltatic = true;
      this.initRouteList();
      this.getDefaultRoutestrategy();
    },
    routeHandleClick(tab) {
      if (tab.name == "1") {
        if (this.huiyiform.strategyType == this.selectItem.strategyTypeMeeting && this.huiyiform.roamRadio == this.selectItem.roamMeeting) {

        } else {
          this.saveConfirm(this.huiyiform.strategyType, this.huiyiform.roamRadio, "meeting")
        }
      } else {
        if (this.juheform.strategyType == this.selectItem.strategyType && this.juheform.roamRadio == this.selectItem.roam) {

        } else {
          this.saveConfirm(this.juheform.strategyType, this.juheform.roamRadio, "juhe")
        }
      }
    },
    status_change: function ({row, rowIndex}) {
      if (row.deleteFlag === 0) {
        return 'warning-row'
      }
      return ''
    },
    editCallback(val) {
      if (val) {
        this.initGroupList();
      }
      this.selectnet = false
      this.bindNEVisible = false
    },
    tactic(row) {
      this.routeActiveName = "1";
      this.route = true;
      this.selectItem = row;
      this.huiyiform.strategyType = this.selectItem.strategyTypeMeeting;
      this.huiyiform.roamRadio = this.selectItem.roamMeeting;
      this.juheform.strategyType = this.selectItem.strategyType;
      this.juheform.roamRadio = this.selectItem.roam;
      this.initRouteList();
    },
    viewNE(item) {
      this.bindNEVisible = true;
      this.groupObject = item;
    },
    select(item) {
      this.selectnet = true;
      this.groupObject = item;
    },
    resetForm() {
      this.selectnet = false;
      this.route = false;
      // this.initGroupList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.initGroupList()

    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.initGroupList()

    },
    // filterGroup() {
    //   var data = {
    //     'pageNo': this.currentPage,
    //     'pageSize': 1,
    //     "token": "",
    //     "keyword": "",
    //     "appkey": "",
    //     "deleteFlag": this.deleteFlag
    //   };
    //   var _this = this;
    //
    //   _this.groupData = [];
    //
    //   this.$axios.post(this.baseUrl3 + 'management3/source/GetPaasGrouplist', data)
    //     .then(({data: {msg, data, code}}) => {
    //       if (code == 20000) {
    //         _this.groupData = data.list;
    //         _this.totalElement = data.totalSize;
    //       } else {
    //         _this.$message({showClose: true, message: msg, type: 'error'});
    //         console.log(msg)
    //       }
    //     })
    //     .catch(err => {
    //       console.log(err)
    //     })
    // },
    searchData() {
      this.currentPage = 1;
      this.initGroupList()
    },
    initGroupList() {
      var data = {
        'pageNo': this.currentPage,
        'pageSize': this.pageSize,
        "token": "",
        'keyword': this.search,
        'appkey': "",
        'deleteFlag': this.isFilter ? this.deleteFlag : null
      };
      var _this = this;

      _this.groupData = [];

      this.$axios.post(this.baseUrl3 + 'management3/source/GetPaasGrouplist', data)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            _this.groupData = data.list;
            _this.totalElement = data.totalSize;
          } else {
            _this.$message({showClose: true, message: msg, type: 'error'});
            console.log(msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    initRouteList() {
      let data = {
        projectSourceId: this.groupuuid,
        groupname: this.groupname,
        groupdesc: this.groupdesc,
        groupAlias: this.groupAlias,
        businessType: Number(this.routeActiveName),
      }
      this.routestrategyArray = [];
      let _this = this;
      this.$axios.post(this.baseUrl3 + 'management3/source/routestrategy', data)
        .then(({data: {msg, data, code}}) => {
          if (code == 0) {
            _this.routestrategyArray = data;
          } else {
            _this.$message({showClose: true, message: msg, type: 'error'});
            console.log(msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    saveRouteClick() {
      if (this.routeActiveName == "1") {
        this.saveRoute(this.juheform.strategyType, this.juheform.roamRadio, "juhe")
      } else {
        this.saveRoute(this.huiyiform.strategyType, this.huiyiform.roamRadio, "meeting")
      }
      this.initGroupList();
    },
    saveRoute(strategyType, roamRadio, type) {
      let businessType = 1;
      if (type == "meeting") {
        businessType = 2
      }
      let data = {
        "projectSourceId": this.selectItem.groupuuid,
        "businessType": businessType,
        "appkey": this.selectItem.appkey,
        "strategyType": strategyType,
        "roam": roamRadio,
        "groupname": this.selectItem.groupname,
        "groupdesc": this.selectItem.groupdesc,
        "groupAlias": this.selectItem.groupAlias ? this.selectItem.groupAlias : this.selectItem.groupname,
      };
      const loading = this.$loading({
        lock: true,
        text: '加载中...',
        // spinner: 'el-icon-loading',
        background: 'rgba(55, 55, 55, 0.4)'
      });
      let _this = this;
      this.$axios.post(this.baseUrl3 + 'management3/source/bindRoutestrategy', data)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            if (type == "meeting") {
              this.selectItem.strategyTypeMeeting = this.huiyiform.strategyType;
              this.selectItem.roamMeeting = this.huiyiform.roamRadio;
            } else {
              this.selectItem.strategyType = this.juheform.strategyType;
              this.selectItem.roam = this.juheform.roamRadio;
            }
            _this.$message({showClose: true, message: "设置成功", type: 'success'})
          } else {
            _this.$message({showClose: true, message: msg, type: 'error'})
            console.log(msg)
          }
          loading.close();
        })
        .catch(err => {
          console.log(err)
          setTimeout(() => {
            loading.close();
          }, 1000);
        })
    }
  },
  computed: {
    ...mapState(['currentMenu', 'listOperations', 'currentMenuOperations']),
    btnInList() {
      return (name, childName) => {
        let btn = this.listOperations.filter(op => op.name.includes(name));
        if (btn && btn.length > 0) {
          if (!childName) {
            return btn.length > 0
          } else {
            return btn[0].buttonList.some(childOp => childOp.name.includes(childName))
          }
        }
      }
    },
  },
  created() {
    this.getListOperations('idclist')
    if (!this.currentMenu) {
      return
    }
    this.initGroupList();
  },
}
</script>

<style>
.check-wrapper {
  display: flex;
  align-items: center; /* 垂直居中对齐 */
}

.loader {
  border: 8px solid #f3f3f3; /* 背景颜色 */
  border-top: 8px solid #3498db; /* 旋转的颜色 */
  border-radius: 50%; /* 圆形 */
  width: 6px; /* 宽度 */
  height: 6px; /* 高度 */
  animation: spin 1s linear infinite; /* 旋转动画 */
  margin-left: 10px; /* 图标与文字之间的间距 */
}

@keyframes spin {
  0% {
    transform: rotate(0deg); /* 初始角度 */
  }
  100% {
    transform: rotate(360deg); /* 结束角度 */
  }
}

.el-tabs__item:focus.is-active.is-focus:not(:active) {
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}

.el-loading-spinner {
  background-image: url('../../../assets/loading1.svg');
  background-size: 63px 100px;
  background-repeat: no-repeat;
  height: 30%;
  background-position: center;
  top: 200px;
}

.el-loading-spinner .circular {
  display: none;
}

.el-loading-spinner .el-loading-text {
  margin-top: 150px;
  text-align: center;
}

.navcss {
  font-size: 17px;
  margin-bottom: 15px;
}

.el-table .warning-row {
  background: oldlace;
}
</style>
